import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { home, person, shieldCheckmark } from 'ionicons/icons';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Dashboard from './pages/dashboard/Dashboard';
import ListApproval from './pages/approval-center/ListApproval';
import Profile from './pages/profile/Profile';
import DetailApproval from './pages/approval-center/DetailApproval';
import Login from './pages/auth/Login';
import ChangePassword from './pages/auth/ChangePassword';

setupIonicReact();

const App: React.FC = () => (
    <IonApp>
        <IonReactRouter>
            <Route path='/login'>
                <Login />
            </Route>
            <Route path='/change-password'>
                <ChangePassword />
            </Route>
            <Route path='/detail-approval/:id'>
                <DetailApproval />
            </Route>
            <Route path='/menu'>
                <IonTabs>
                    <IonRouterOutlet>
                        <Route exact path="/menu/dashboard">
                            <Dashboard />
                        </Route>
                        <Route exact path="/menu/approval-center">
                            <ListApproval />
                        </Route>
                        <Route path="/menu/profile">
                            <Profile />
                        </Route>
                    </IonRouterOutlet>
                    <IonTabBar slot="bottom">
                        <IonTabButton tab="menu/dashboard" href="/menu/dashboard">
                            <IonIcon aria-hidden="true" icon={home} />
                            <IonLabel>Dashboard</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="menu/approval-center" href="/menu/approval-center">
                            <IonIcon aria-hidden="true" icon={shieldCheckmark} />
                            <IonLabel>Approval Center</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="menu/profile" href="/menu/profile">
                            <IonIcon aria-hidden="true" icon={person} />
                            <IonLabel>Profil</IonLabel>
                        </IonTabButton>
                    </IonTabBar>
                </IonTabs>
            </Route>
            {/* <IonTabs>
                // Login
                // Dashboard
                // Notifications
                // Profile
                // Approval Center
                <IonRouterOutlet>
                    <Route exact path="/tab1">
                        <Tab1 />
                    </Route>
                    <Route exact path="/tab2">
                        <Tab2 />
                    </Route>
                    <Route path="/tab3">
                        <Tab3 />
                    </Route>
                    <Route exact path="/">
                        <Redirect to="/tab1" />
                    </Route>
                </IonRouterOutlet>
                <IonTabBar slot="bottom">
                    <IonTabButton tab="tab1" href="/tab1">
                        <IonIcon aria-hidden="true" icon={triangle} />
                        <IonLabel>Tab 1</IonLabel>
                    </IonTabButton>
                    <IonTabButton tab="tab2" href="/tab2">
                        <IonIcon aria-hidden="true" icon={ellipse} />
                        <IonLabel>Tab 2</IonLabel>
                    </IonTabButton>
                    <IonTabButton tab="tab3" href="/tab3">
                        <IonIcon aria-hidden="true" icon={square} />
                        <IonLabel>Tab 3</IonLabel>
                    </IonTabButton>
                </IonTabBar>
            </IonTabs> */}
            <Route exact path="/">
                <Redirect to="/menu/dashboard" />
            </Route>
        </IonReactRouter>
    </IonApp>
);

export default App;
